/**
 * connected-handlers-view.js
 */

import React from 'react';
import {
  Typography,
  IconButton,
  List,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { UserContext } from 'contexts/user/user-context';
import DrawerContentBuilder from 'components/menu-drawer/drawer-content-builder';
import DrawerContent from 'components/menu-drawer/drawer-content';
import IconSection from 'components/icon-section';
import Icon from 'components/icon';
import CaptionedSvg from 'components/captioned-svg';
import GroupMember from 'components/groups/group-member';
import { ConnectedHandlersContext } from './connected-handlers-context';
import { ReactComponent as ConnectionsSvg } from 'assets/images/connections.svg';


export default function ConnectedHandlersView(props) {
  const { basePath } = props;
  const { user } = React.useContext(UserContext);
  const { handlers } = React.useContext(ConnectedHandlersContext);
  const title = 'Connected Handlers';


  const closeButton = (
    <IconButton
      data-testid="back-button"
      size="small"
      style={{color: 'inherit'}}
      component={Link}
      to={basePath}      
      children={<Icon type='mobile-close-drawer' />}
    />
  );


  return (
    <>
      <DrawerContentBuilder
        mobileAppBar={{
          title: 'Connected Handlers',
          leftActions: closeButton,
        }}
        desktopHeader={{ title }}
        children={(
          <DrawerContent>
            {handlers.length > 0 &&
            <IconSection iconName='group-handlers'>
              <Typography variant='subtext-small' sx={{ mb: 2 }}>
                {user.role.isHandler && <>These are the PACKTRACK handlers that you know. You're automatically connected to handlers who share the same supervisor, trainer or training group.</>}
                {user.role.isTrainer && <>These are the PACKTRACK handlers that you know. You're automatically connected to the training groups of handlers that you directly train. The handlers in these training groups are listed below.</>}
              </Typography>

              <List>{handlers.map(h => <GroupMember key={h.id} member={h} />)}</List>
            </IconSection>}

            {handlers.length === 0 &&
            <CaptionedSvg
              image={<ConnectionsSvg />}
              text={<>You aren't connected with any handlers. Use the Manage page to invite handlers to be trained. Your trained handlers, as well as any handlers in their training groups, will be listed here.</>}
            />}
          </DrawerContent>
        )}
      />
    </>
  );
}